export enum CrmEntityNames {
  MarketingList = 'list',
  User = 'systemuser',
  Contact = 'contact',
  Lead = 'lead',
  Account = 'account',
  Team = 'team',
  Workflow = 'workflow',
  EmailTemplate = 'cdi_emailtemplate',
  EmailSend = 'cdi_emailsend',
  WebForm = 'cdi_webcontent',
  FormCapture = 'cdi_formcapture',
  FormField = 'cdi_formfield',
  SurveyQuestion = 'cdi_surveyquestion',
  Domain = 'cdi_domain',
  Campaign = 'campaign',
  EmailCName = 'cdi_emailcname',
  Currency = 'transactioncurrency',
  Event = 'cdi_event',
  ContactAttributes = 'contact_attributes',
  LeadAttributes = 'lead_attributes',
  SubscriptionList = 'cdi_subscriptionlist'
}

